export const CROSSALE_STEPS = {
  SELECT_DOMAINS: 'selectDomains',
  SETUP_DOAMINS: 'setupDomains',
  NON_WP: 'nonWp',
} as const

export type CrossaleSteps = (typeof CROSSALE_STEPS)[keyof typeof CROSSALE_STEPS]

export interface DomainToSelect extends DomainToSetup {
  id: number
  botZappingPluginActivated: boolean
  paidMarketingConnected: boolean
  botZappingConnected: boolean
  tagUrl: string
  tagHashCode: string
  isNewlyCreated?: boolean // for created domains that can't be unselected
  tagId: number
}

export const EMPTY_DOMAIN = {
  address: '',
  wordpress: false,
  isBzMonitor: false,
  isSelected: false,
}

export interface DomainToSetup {
  isBzMonitor: boolean
  isSelected: boolean
  wordpress: boolean
  address: string
}

export interface DomainTableColumn {
  key: string
  accessor: string
  flexStart: boolean
  flex: number
}

export const DOMAINS_TABLE_COLUMNS: DomainTableColumn[] = [
  {
    key: 'address',
    accessor: 'isSelected',
    flexStart: true,
    flex: 2,
  },
  {
    key: 'wordpress',
    accessor: 'wordpress',
    flexStart: false,
    flex: 1,
  },
  {
    key: 'isBzMonitor',
    accessor: 'isBzMonitor',
    flexStart: false,
    flex: 1.2,
  },
]

export type DomainsTableColumns = (typeof DOMAINS_TABLE_COLUMNS)[number]['accessor']
